import { MouseEvent } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import SETVIImage from '../setvi-image';
import { Overlay } from './overlay';
import { Resource } from '../../interfaces';
import { useResourceOpener } from '../../providers/resource-opener';

const useStyles = makeStyles({
  imageContainer: {
    position: 'relative',
    cursor: 'pointer'
  },
  panelImage: {
    width: 70,
    height: 52,
    borderRadius: 6,
    objectFit: 'cover'
  }
});

interface SResourceThumbProps {
  thumbUrl: Resource['ThumbURLWithSas'];
  name: Resource['Name'];
  resourceID: Resource['ResourceID'];
  resourceTypeID: Resource['ResourceTypeID'];
  /** Numeric id so the preview can fetch the resource. */
  id?: Resource['ID'];
}

export const SResourceThumb = ({
  thumbUrl,
  name,
  resourceID,
  resourceTypeID,
  id
}: SResourceThumbProps) => {
  const classes = useStyles();
  const { openResource } = useResourceOpener();

  const onThumbnailClick = (e: MouseEvent) => {
    e.stopPropagation();
    openResource({
      name,
      resourceId: resourceID,
      resourceTypeId: resourceTypeID,
      id
    });
  };

  return (
    <Box className={classes.imageContainer} onClick={onThumbnailClick}>
      <SETVIImage
        className={classes.panelImage}
        src={thumbUrl}
        alt="Resource"
        loading="lazy"
      />
      <Overlay />
    </Box>
  );
};
